import matchEntities from '../shared/entityHelpers';
import featureFlags from '../../utils/featureFlags';

export default [
  {
    name: 'navigation.block_qwello',
    links: [
      {
        text: 'navigation.experience',
        ref: '/experience',
      },
      {
        text: 'navigation.process',
        ref: '/procesbeschrijving',
        hide: !matchEntities(['NETHERLANDS']),
      },
      {
        text: 'navigation.map',
        ref: 'https://qwello.eu/en/map',
        isExternal: true,
      },

      {
        text: 'News',
        ref: 'https://qwello.eu/news/',
        isExternal: true,
      },
    ],
  },
  {
    name: 'navigation.block_legal',
    links: [
      {
        text: 'navigation.terms',
        ref: '/terms',
      },
      {
        text: 'navigation.privacy',
        ref: '/privacy',
      },
      {
        text: 'navigation.cookie_settings',
        isAction: 'cookieSettings',
        hide: !featureFlags.enabledCookieSettings(),
      },
      {
        text: 'navigation.manual',
        ref: '/manual',
      },
      {
        text: 'navigation.impressum',
        ref: '/impressum',
      },
    ],
  },
  {
    name: 'navigation.block_charging',
    links: [
      {
        text: 'navigation.invoice',
        ref: '/receipt',
      },
      {
        text: 'navigation.transparency',
        ref: '/transparency',
        hide: matchEntities(['POLAND', 'NETHERLANDS']),
      },
    ],
  },
];

// Entities with a minimal layout (see isMinimalLayoutEntity) show these links
// in one row instead of the blocks above. Order is the order they appear in.
export const minimalFooterLinks = [
  {
    text: 'navigation.terms',
    ref: '/terms',
  },
  {
    text: 'navigation.privacy',
    ref: '/privacy',
  },
  {
    text: 'navigation.cookie_settings',
    isAction: 'cookieSettings',
    hide: !featureFlags.enabledCookieSettings(),
  },
  {
    text: 'navigation.impressum',
    ref: '/impressum',
  },
  {
    text: 'navigation.invoice',
    ref: '/receipt',
  },
  {
    text: 'navigation.register',
    ref: '/register',
    hide: matchEntities(['NETHERLANDS']),
  },
  {
    text: 'navigation.manual',
    ref: '/manual',
  },
  {
    text: 'navigation.transparency',
    ref: '/transparency',
    hide: matchEntities(['POLAND', 'NETHERLANDS']),
  },
];
